var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "OnboardingLayout",
    {
      attrs: {
        title: _vm.$t("onboarding.features.title"),
        subtitle: _vm.$t("onboarding.features.subtitle"),
        "can-proceed": _vm.canProceed,
        "progress-bar1": 100,
        "progress-bar2": 100,
        "skip-button-label": _vm.$t("onboarding.common.back"),
      },
      on: { next: _vm.handleNext, skip: _vm.handleSkip },
    },
    [
      _c(
        "div",
        { staticClass: "onboarding-features-grid" },
        _vm._l(_vm.availableFeatures, function (feature) {
          return _c("FeatureCard", {
            key: feature.id,
            attrs: { feature: feature, selected: _vm.isSelected(feature.id) },
            on: {
              click: function ($event) {
                return _vm.toggleFeature(feature.id)
              },
            },
          })
        }),
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }